import { createFeature, createReducer, on } from '@ngrx/store';
import * as SkuSearchSortByActions from './sort-by.actions';

export interface SortOptionsByPageState {
    sortByRLP: string;
    orderByRLP: string;
    sortByTLP: string;
    orderByTLP: string;
}

export const sortOptionsByPageFeatureKey = 'sortOptionsByPage';

export const initialSortOptionsByPage: SortOptionsByPageState = {
    sortByRLP: '',
    orderByRLP: 'descending',
    sortByTLP: '',
    orderByTLP: 'descending'
};

export const sortOptionsByPageFeature = createFeature({
    name: sortOptionsByPageFeatureKey,
    reducer: createReducer(
        initialSortOptionsByPage,
        on(SkuSearchSortByActions.setSortByResultsPage, (state, { sortBy }) => ({
            ...state,
            sortByRLP: sortBy
        })),
        on(SkuSearchSortByActions.setOrderByResultsPage, (state, { orderBy }) => ({
            ...state,
            orderByRLP: orderBy
        })),
        on(SkuSearchSortByActions.setSortByTimeline, (state, { sortBy }) => ({
            ...state,
            sortByTLP: sortBy
        })),
        on(SkuSearchSortByActions.setOrderByTimeline, (state, { orderBy }) => ({
            ...state,
            orderByTLP: orderBy
        })),
        on(SkuSearchSortByActions.clearSortOptions, () => {
            return initialSortOptionsByPage;
        }))
});